import React from 'react'
import { useState, useEffect } from 'react'
import {motion} from 'framer-motion';
import {fadeIn} from '../variants';
import {Helmet} from "react-helmet";

const {REACT_APP_SPOTIFY_CLIENT_ID, REACT_APP_SPOTIFY_CLIENT_SECRET} = process.env;

function Spotify() {
  const [searchInput, setSearchInput] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [albums, setAlbums] = useState([]);
  
  useEffect(() => {
    //API Access token
    var authParameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'grant_type=client_credentials&client_id=' +  REACT_APP_SPOTIFY_CLIENT_ID + '&client_secret=' + REACT_APP_SPOTIFY_CLIENT_SECRET
    }
    fetch('https://accounts.spotify.com/api/token', authParameters)
      .then(result => result.json())
      .then(data => setAccessToken(data.access_token))
  }, [])

  //Search
  async function search() {
    if (!searchInput.trim()) {
      console.log("Search input is empty.");
      return (
        <div className="color-red-500">
          Please enter an album to search in the search bar
        </div>
      )
    }
    
    console.log("Search for " + searchInput);
    
    // Get request to get Artist ID
    var searchParameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accessToken
      },
    };
  
    try {
      var artistIDResponse = await fetch('https://api.spotify.com/v1/search?q=' + searchInput + '&type=artist' , searchParameters);
      var artistIDData = await artistIDResponse.json();
      
      if (artistIDData.artists.items.length === 0) {
        console.log("No artist found for the given search input.");
        return; // return early if no artist found
      }
      
      var artistID = artistIDData.artists.items[0].id;
      console.log("Artist ID is " + artistID);
      
      var albumsResponse = await fetch('https://api.spotify.com/v1/artists/' + artistID + '/albums?include_groups=album&market=US&limit=50', searchParameters);
      var albumsData = await albumsResponse.json();
      
      console.log(albumsData);
      setAlbums(albumsData.items);
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
      // Handle error accordingly
    }
  }
  //console.log(albums)


  return (
    <motion.div
    variants={fadeIn('up', 0.2)} 
    initial="hidden"
    whileInView={'show'} 
    viewport={{once: true, amount:0.2}} 
    className='container mx-auto min-h-screen my-12'>
      <Helmet>  
        <title>Spotify Album Search</title>
      </Helmet>
      <h1 className='h2 text-gradient'>
        Spotify Album Search
      </h1>
      <div className="text-green-600 my-4">
        Enter your favourite music artist
      </div>
      <div className=" space-y-5">
        <div className='max-w-sm'>
          <div className="flex gap-3">
            <input 
              type="input"
              placeholder='Search for Artist'
              className="py-2 px-3 pe-11 block w-full border-gray-200 shadow-sm rounded-full text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none text-black"
              onKeyUp={(event) => {
                  if (event.key === "Enter") {
                    search();
                  }
              }}
              onChange={event=> setSearchInput(event.target.value)}
            />
            <button 
              className='btn-green p-2'
              onClick={search}
            >
              <p>Search</p>
            </button>
          </div>
          {search}
          
        </div>
        <div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full">
            {albums.map( (album, i) => {
              return (
                <a href={album.external_urls.spotify} target="_blank" rel="noreferrer">
                  <div className='max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 flex flex-col h-full'>
                    <img src={album.images[0].url} alt="" />
                    <h3>{album.name}</h3>
                  </div>
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Spotify
